export default __webpack_public_path__ + "static/media/Elsie 9781408355183.686782de.jpg";